import Vue from "vue";
import axios from "axios";

export default {};

export const utils = {
  install(Vue) {
    Vue.prototype.$utils = {
      separateThousands: function (text) {
        var result = "";
        var newText = (text + "").replace(/,/g, "");
        for (var i = 1; i <= newText.length; i++) {
          result = newText.charAt(newText.length - i) + result;
          if (i % 3 === 0 && i !== newText.length) {
            result = "," + result;
          }
        }
        return result;
      },
      getCardNumber: function (text) {
        var result = "";
        var newText = (text + "").replace(/-/g, "");
        for (var i = 1; i <= newText.length; i++) {
          result = newText.charAt(newText.length - i) + result;
          if (i % 4 === 0 && i != newText.length) {
            result = "-" + result;
          }
        }
        return result;
      },
      toNumber: function (text) {
        let number = text * 1;
        return number;
      },
      toText: function (number) {
        let text = number + "";
        return text;
      },
      lpad: function (text, padString, length) {
        // 숫자 앞에 0 붙이기
        let str = "" + text;
        while (str.length < length) str = padString + str;
        return str;
      },
      itemStyle(condition, name, color) {
        if (condition) {
          return name + ":" + color;
        } else {
          return "";
        }
      },
      textValue(text) {
        if (this.isEmpty(text) === false) return text;
        else return "";
      },
      numberValue(number) {
        if (this.isEmpty(number) === false) return number;
        else return 0;
      },
      getShortened(text, maxLength) {
        let result = text + "";
        if (text.length > maxLength) {
          result = text.slice(0, maxLength) + "..";
        }
        return result;
      },
      isEmpty(text) {
        if (
          text === undefined ||
          typeof text === "undefined" ||
          text === null ||
          text.length === 0
        ) {
          return true;
        } else {
          return false;
        }
      },
      isSameDate(date1, date2) {
        if (Number(date1) === Number(date2)) {
          return true;
        } else {
          return false;
        }
      },
      isSameDay(date1, date2) {
        let result = false;
        if (date1.getFullYear() === date2.getFullYear()) {
          if (date1.getMonth() === date2.getMonth()) {
            if (date1.getDate() === date2.getDate()) {
              result = true;
            }
          }
        }
        return result;
      },
      getPhoneText: function (text) {
        var result = "";
        var newText = (text + "").replace(/-/g, "");
        newText = (newText + "").replace(/ /g, "");
        for (var i = 1; i <= newText.length; i++) {
          result = newText.charAt(newText.length - i) + result;
          if (i % 4 === 0 && i != newText.length) {
            result = "-" + result;
          }
        }
        return result;
      },
      onInput(text, object, regExp, maxLength, nextFocus, onMessage) {
        var result = text + "";
        if (regExp != null) {
          var matched = result.match(regExp);
          if (matched != null) {
            let matchedText = "";
            for (let i = 0; i < matched.length; i++) {
              matchedText += matched[i];
            }
            result = matchedText;
          } else {
            result = "";
          }
          if (result.length != text.length) {
            if (onMessage != null) {
              onMessage(text);
            }
          }
        }
        if (maxLength != null) {
          result = result.substring(0, maxLength);
        }
        object.lazyValue = result;
        if (nextFocus != null) {
          if (result.length === maxLength) {
            nextFocus.focus();
          }
        }
        return result;
      },
      getWeekday(date) {
        let weekday = date.getDay();
        if (weekday === 0) {
          return "일";
        } else if (weekday === 1) {
          return "월";
        } else if (weekday === 2) {
          return "화";
        } else if (weekday === 3) {
          return "수";
        } else if (weekday === 4) {
          return "목";
        } else if (weekday === 5) {
          return "금";
        } else if (weekday === 6) {
          return "토";
        }
        return 0;
      },
      randomValue(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      createPhoneAuthCode() {
        return this.randomValue(100000, 999999) + "";
      },
      createHospitalCode() {
        return this.randomValue(10000, 99999) + "";
      },
      getSecondsDiff(startDate, endDate) {
        const msInSecond = 1000;
        return Math.round(Math.abs(endDate - startDate) / msInSecond);
      },
      getResidentNumber(text) {
        let numbers = text;
        if (text.length >= 8) {
          numbers = text.substring(0, 8);
          numbers += "******";
        }
        return numbers;
      },
      getPrivateResidentNumber(text) {
        let numbers = text;
        if (text.length >= 8) {
          numbers = text.substring(0, 8);
          numbers += "******";
        }
        return numbers;
      },
      getTelPhoneText: function (text) {
        let phoneNumber = text + "";
        let phone1 = "";
        let phone2 = "";
        let phone3 = "";
        if (phoneNumber.startsWith("02")) {
          // phone1: 앞 2자리, phone3: 뒤 4자리, phone2: 나머지
          phone1 = phoneNumber.slice(0, 2);
          phone2 = phoneNumber.slice(2, phoneNumber.length - 4);
          phone3 = phoneNumber.slice(phoneNumber.length - 4);
        } else {
          let areaCodes = [
            "031",
            "032",
            "033",
            "041",
            "042",
            "043",
            "044",
            "051",
            "052",
            "053",
            "054",
            "055",
            "061",
            "062",
            "063",
            "064",
          ];
          let areaCode = phoneNumber.slice(0, 3);
          if (areaCodes.includes(areaCode)) {
            // phone1: 앞 3자리, phone3: 뒤 4자리, phone2: 나머지
            phone1 = phoneNumber.slice(0, 3);
            phone2 = phoneNumber.slice(3, phoneNumber.length - 4);
            phone3 = phoneNumber.slice(phoneNumber.length - 4);
          } else {
            // 4자리씩 구분
            let phoneNumbers = this.getPhoneText(phoneNumber).split("-");
            if (phoneNumbers.length > 2) {
              phone1 = phoneNumbers[0];
              phone2 = phoneNumbers[1];
              phone3 = phoneNumbers[2];
            }
          }
        }
        return phone1 + "-" + phone2 + "-" + phone3;
      },
      getSmsLength: function (str) {
        var len = 0;
        if (str != null && str !== undefined) {
          for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            if (
              c > 128 ||
              c === 0x22 ||
              c === 0x27 ||
              c === 0x2f ||
              c === 0x5c ||
              c === 0x7c
            ) {
              // ", ', /, \, |
              len += 2;
            } else if (c === 0x0d) {
              // 0x0A 에서 1카운트 0x0D 는 무시
              len += 0;
            } else {
              len += 1;
            }
          }
        }
        return len;
      },
      validateResidentNumber: function (rrn) {
        if (rrn.length !== 13) {
          return false;
        }

        var weight = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
        var sum = 0;
        for (var i = 0; i < 12; i++) {
          sum += parseInt(rrn.charAt(i)) * weight[i];
        }

        var checkDigit = (11 - (sum % 11)) % 10;

        if (parseInt(rrn.charAt(12)) === checkDigit) {
          return true;
        } else {
          return false;
        }
      },
      validateBizRegNumber: function (bizRegNumber) {
        if (bizRegNumber.length !== 10) {
          return false;
        } else {
          return true;
        }
      },
      async createShortUrl(url, key = "") {
        let baseUrl = "https://flydoc.kr";
        let shortUrl = "";
        try {
          let apiUrl = baseUrl + "/api/set";
          let headers = {
            "Content-Type": "application/json",
            "X-URL": url,
            "X-CLIENT-TOKEN": "0uU4t0Jzritr7iz9zCnH",
          };
          if (key !== "") {
            headers["X-KEY"] = key;
          }
          await axios
            .get(apiUrl, { headers: headers })
            .then((response) => (shortUrl = response.data))
            .catch(function (error) {
              console.log(error);
              shortUrl = "error1";
            });
        } catch (e) {
          console.log(e);
          shortUrl = "error2";
        }
        return shortUrl;
      },
      getQRUrl(url) {
        let urlData = url.split("/", 4);
        return "https://" + urlData[2] + "/qr/" + urlData[3];
      },
    };
  },
};

Vue.use(utils);
